var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attachment-preview"},[_c('span',{staticClass:"span",on:{"click":function($event){return _vm.attachmentPreview(_vm.data)}}},[_vm._t("Text")],2),_c('attachment-dialog',{ref:"attachment",attrs:{"propsData":_vm.attachmentDialogProps,"src":_vm.src,"typeFile":_vm.typeFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }